import { useState, useEffect } from 'react';
import { Box, Typography, Button, Dialog, DialogContent, Link } from '@mui/material';
import CloseIcon from '@mui/icons-material/Close';
import { useCookies } from 'react-cookie';
import { brand } from '../getTheme/getTheme';

const ShowOnceModal = ({ cookieName, children, onClose, open: externalOpen, onOpenChange }) => {
    const [internalOpen, setInternalOpen] = useState(false);
    const [cookies, setCookie] = useCookies([cookieName]);
    
    // Use external open state if provided (controlled), otherwise use internal state
    const isControlled = externalOpen !== undefined;
    const open = isControlled ? externalOpen : internalOpen;
    
    useEffect(() => {
        if (!isControlled) {
            //setOpen(cookies[cookieName] !== 1);
            setInternalOpen(cookies[cookieName] !== 1);
        }
    }, [cookies, cookieName, isControlled]);

    const handleClose = () => {
        if (isControlled && onOpenChange) {
            onOpenChange(false);
        } else {
            setInternalOpen(false);
        }
        setCookie(cookieName, "1", { path: "/", expires: new Date(Date.now() + 1 * 24 * 60 * 60 * 1000) });
        if (onClose) onClose();
    };

    return (
        <Dialog
            open={open}
            onClose={handleClose}
            sx={{
                display: { xs: 'block', md: 'block' },
                '& .MuiDialog-container .MuiPaper-root': { width: { xs: '90%', md: '40%' }, maxWidth: { xs: '400px', md: '400px' }, mx: { xs: 2, md: 'auto' } },
            }}
        >
            <DialogContent sx={{ boxShadow: 24, border: '1px solid var(--brand-main)', borderRadius: '16px', p: 4, position: 'relative' }}>
                <CloseIcon onClick={handleClose} sx={{ position: 'absolute', top: 8, right: 8, cursor: 'pointer' }} />
                {typeof children === 'function' ? children(handleClose) : children}
            </DialogContent>
        </Dialog>
    );
};

export const GeographyPreviewModal = ({ geography }) => {
    const [externalOpen, setExternalOpen] = useState(undefined); // undefined = uncontrolled (auto-show)

    // Listen for custom event to open modal from anywhere
    useEffect(() => {
        const handleOpen = () => setExternalOpen(true);
        window.addEventListener('openPreviewModal', handleOpen);
        return () => window.removeEventListener('openPreviewModal', handleOpen);
    }, []);

    if (geography !== 'hk' && geography !== 'sg') return null;

    const geographyName = geography === 'hk' ? 'Hong Kong' : 'Singapore';

    return (
        <ShowOnceModal 
            cookieName={`GEOGRAPHY_PREVIEW_${geography.toUpperCase()}`}
            open={externalOpen}
            onOpenChange={setExternalOpen}
        >
            {(handleClose) => (
                <>
                    {/* <Stack spacing={3} sx={{ alignItems: 'center', mb: 3 }}>
                        <Typography variant="h6" sx={{ color: brand[200], textAlign: 'center' }} paragraph>
                            Preview Mode
                        </Typography>
                    </Stack> */}
                    <Typography variant="body1" paragraph>
                        You're viewing a <Box component="span" sx={{ fontWeight: 'bold', color: brand[200] }}>preview</Box> of our {geographyName} data based on filings through <Box component="span" sx={{ fontWeight: 'bold', color: brand[200] }}>FY 2024.</Box> 
                    </Typography>
                    <Typography variant="body1" paragraph>
                        For access to data updated daily across all listings, please{' '}
                        <Link href="/inquiry" sx={{ color: brand[200], textDecoration: 'underline', '&:hover': { color: brand[300] } }}>
                            contact us for an enterprise license.
                        </Link>
                    </Typography>
                    <Box sx={{ display: 'flex', justifyContent: 'center', mt: 3 }}>
                        <Button
                            variant="contained"
                            onClick={handleClose}
                            sx={{ 
                                backgroundColor: '#FFAA00', 
                                color: '#000000', 
                                fontWeight: 'bold',
                                borderRadius: '4px',
                                '&:hover': { backgroundColor: '#E69900' },
                                textTransform: 'none'
                            }}
                        >
                            Continue to PREVIEW
                        </Button>
                    </Box>
                </>
            )}
        </ShowOnceModal>
    );
};

